import { useDynamicEntity } from './useDynamicEntity';
import { useAuth } from './index';

export const useInvoiceCodes = () => {
  const { user } = useAuth();
  const dynamicHook = useDynamicEntity({
    entityType: 'invoiceCodes',
    gqlEntityKey: 'invoice_codes',
    queryName: 'GET_INVOICE_CODES_QUERY',
    createMutation: 'CREATE_INVOICE_CODES_MUTATION',
    updateMutation: 'UPDATE_INVOICE_CODES_MUTATION',
    deleteMutation: 'DELETE_INVOICE_CODES_MUTATION',
    updateVariableName: 'set',
    transformData: (invoiceCodes) => ({
      ...invoiceCodes,
      company_name: invoiceCodes.company?.name || `Company ${invoiceCodes.company_id}`,
      code_name: invoiceCodes.code_name,
      product_name: invoiceCodes.product_name,
      description: invoiceCodes.description,
      companyId: invoiceCodes.company_id,
    }),
    transformFormData: (formData) => ({
      code_name: formData.code_name,
      description: formData.description || null,
      product_name: formData.product_name,
      company_id: formData.companyId,
    }),
    customWhereCondition: user?.role === 'ROOT' ? {} : { company_id: { _eq: user?.companyId } },
  });
  return {
    ...dynamicHook,
    isRootUser: user?.role === 'ROOT',
  };
};

